export default __webpack_public_path__ + "static/problem_2-dfad8deb6478d766223a2f96ab14cbd5.png";